import React, { useContext } from "react";
import _ from "lodash";
import { Form, Col } from "react-bootstrap";
import { Select, MenuItem } from "@material-ui/core";
import { RECORD_TYPES, MEDIA_SEARCH, EMPTY_CANTEMO_FILTERS } from "../../constants/MediaSearch";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import "../../styles/media-search.scss";

const MediaType = () => {
    const {
        recordType,
        _setOptions,
        _setRecordType,
        _setSuggestString,
        _setSelectedOption,
        _setValidAssets,
        _setOdsEditsData,
        _setIdType,
        _setIdQueryType,
        _setIdTypeValues,
        _setCantemoFilters,
        _setOdsSearchIdsData,
        _setSeasonData,
        _setEpisodeData,
    } = useContext(MediaRequestContext);

    return (
        <Form.Group className="m-0 p-0" as={Col} controlId="recordType">
            <Form.Label className="media-request-formLabel">{MEDIA_SEARCH.recordTypeFormLabel}</Form.Label>
            <Form.Control
                as={Select}
                disableUnderline={true}
                displayEmpty
                classes={{
                    disabled: "formSelectDisabled"
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    getContentAnchorEl: null,
                }}
                value={recordType}
                onChange={(e) => {
                    _setRecordType(e.target.value);
                    _setOptions([]);
                    _setSuggestString('');
                    _setSelectedOption('');
                    _setOdsEditsData({});
                    _setOdsSearchIdsData({});
                    _setValidAssets({});
                    _setIdType("");
                    _setIdQueryType("");
                    _setIdTypeValues("");
                    _setCantemoFilters({ ...EMPTY_CANTEMO_FILTERS });
                    _setSeasonData([]);
                    _setEpisodeData({});
                }}
                className={"formInputSelect"}
            >
                <MenuItem className="dropdownSelect" value="">
                    -----
                </MenuItem>
                {_.map(RECORD_TYPES, (recordType, index) => {
                    return (
                        <MenuItem
                            className="dropdownSelect"
                            key={index}
                            value={_.get(recordType, "value")}
                        >
                            {_.get(recordType, "label")}
                        </MenuItem>
                    );
                })}
            </Form.Control>
        </Form.Group>
    )
}

export default MediaType;